import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'op-vehicle-search',
    templateUrl: './vehicle-search.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class VehicleSearchComponent {
}